import * as styles from "./SideMenu.styles";

interface Props {
  isSideMenuOpen: boolean;
  onMouseEnter: () => void;
  onMouseLeave: () => void;
  children: React.ReactNode;
}

const SideMenu = ({ isSideMenuOpen, onMouseEnter, onMouseLeave, children }: Props) => (
  <div
    css={[styles.sideMenu, isSideMenuOpen && styles.open]}
    onMouseEnter={onMouseEnter}
    onMouseLeave={onMouseLeave}
    role="menu"
    aria-label="Subcategories menu"
  >
    {children}
  </div>
);

export { SideMenu };
